var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('Feature',{attrs:{"title":'功能權限維護',"iconClass":'fa-user-circle-o'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }